import { UpcomingEvent } from '../../models';

export const type = 'upcoming-events';

export interface UpcomingEventsState {
    items: UpcomingEvent[];
    isFetching: boolean;
    errorMessage?: string;
    lastFetchedCustomerId?: number;
}

export const initialState: UpcomingEventsState = {
    items: [],
    isFetching: false,
    errorMessage: undefined,
    lastFetchedCustomerId: undefined,
};
